import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode, USER_ROLE} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";
import {Messages, showMessage} from "@app/constants/Messages";
import JobSendRequestNoteContent from "@pages/candidate/detail/JobSendRequestNoteContent";
import Select from "react-select";
import {cloneDeep} from "lodash";
import {monthOptions, yearOptions} from "@app/utils/CommonUtils";
import {Provinces} from "@app/constants/Provinces";
import {showSuccessMessageSaveData} from "@pages/candidate/Common";
import {requestGetEmployeeList} from "@app/services/EmployeeService";
import {requestGetEmployerList} from "@app/services/EmployerService";
import {Link} from "react-router-dom";
import {Document, Page} from "react-pdf";
import {requestDownloadCV} from "@app/services/ExtractService";

const CandidateCVFiles = (props) => {
    const [fetchingCV, setFetchingCV] = useState(false);
    const [currCVIndex, setCurrCVIndex] = useState(0);
    const [curriculumVitaes, setCurriculumVitaes] = useState([]);
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const {candidateId, currCV, onSelectCurrentCV} = props

    const fetchCandidateCV = (canId) => {
        setFetchingCV(true)
        CandidateService.getCandidateCVDetail(canId).then((res) => {
            let cvList = res.content
            setCurriculumVitaes(cvList)
            if (cvList.length > 0) {
                const tmpCurrCV = cvList[currCVIndex]
                onSelectCurrentCV(tmpCurrCV)
                let userLogin = userLoginInfo
                if (!userLogin.id) {
                    userLogin = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
                }
                const cvDisplay = (userLogin.id === tmpCurrCV.created_user || userLogin.is_superuser) ? tmpCurrCV.origin_cv : tmpCurrCV.hide_contact_cv
                requestDownloadCV(cvDisplay).then(url => {
                    tmpCurrCV.cv_display_url = url
                    setCurriculumVitaes(cloneDeep(cvList));
                })
            }
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình tải CV.`);
        }).finally(() => {
            setFetchingCV(false)
        });
    };

    const deleteCandidateCV = (id) => {
        CandidateService.deleteCandidateCV({cv_id: id}).then((res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                toast.success(`Xóa CV thành công.`);
                let cvList = cloneDeep(curriculumVitaes);
                cvList.splice(currCVIndex, 1);
                let nextCVIndex = currCVIndex
                if (nextCVIndex > cvList.length - 1) {
                    nextCVIndex = cvList.length - 1
                    setCurrCVIndex(nextCVIndex);
                }
                setCurriculumVitaes(cvList)
                requestDownloadCV(cvList[nextCVIndex].origin_cv).then(url => {
                    cvList[nextCVIndex].cv_display_url = url
                    setCurriculumVitaes(cloneDeep(cvList));
                })

            } else {
                toast.error(`Xóa CV thất bại.`);
            }
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xóa CV.`);
        })
    };

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }

        if (candidateId) {
            fetchCandidateCV(candidateId)
        }
    }, [])

    useEffect(() => {
        if (curriculumVitaes.length > 0) {
            const tempCurrCV = curriculumVitaes[currCVIndex]
            if (currCV.id === tempCurrCV.id) {
                currCV.cv_display_url = tempCurrCV.cv_display_url
                curriculumVitaes[currCVIndex] = currCV
                setCurriculumVitaes([...curriculumVitaes])
            }
        }
    }, [currCV])

    const onCVDelete = () => {
        let text = "Bạn chắc chắn muốn xóa CV?";
        if (window.confirm(text) === true) {
            deleteCandidateCV(curriculumVitaes[currCVIndex].id)
        }
    };

    const updateCVIndex = (newIndex) => {
        setCurrCVIndex(newIndex);
        const selectedCV = curriculumVitaes[newIndex];
        const cvDisplay = userLoginInfo.id === selectedCV.created_user
            ? selectedCV.origin_cv
            : selectedCV.hide_contact_cv;

        setFetchingCV(true);

        requestDownloadCV(cvDisplay).then((url) => {
            selectedCV.cv_display_url = url;
            const newCVs = cloneDeep(curriculumVitaes);
            setCurriculumVitaes(newCVs);
            onSelectCurrentCV(newCVs[newIndex]);
        }).finally(() => {
            setFetchingCV(false);
        });
    };

    const onCVNext = () => {
        const nextIndex = currCVIndex + 1;
        if (nextIndex < curriculumVitaes.length) {
            updateCVIndex(nextIndex);
        }
    };

    const onCVBack = () => {
        const prevIndex = currCVIndex - 1;
        if (prevIndex >= 0) {
            updateCVIndex(prevIndex);
        }
    };


    const onLoadSuccess = async (pdfInfo, index) => {
        curriculumVitaes[index].numPages = [];
        for (let i = 1; i <= pdfInfo.numPages; i++) {
            curriculumVitaes[index].numPages.push(i);
        }
        setCurriculumVitaes([...curriculumVitaes]);
    };

    return (
        <>
            {curriculumVitaes && curriculumVitaes.length > 0 &&
                // curriculumVitae[currCVIndex].origin_cv &&
                <div className='card card-default'>
                    <div className='card-header'>
                        <h3 className='card-title text-bold'>{curriculumVitaes[currCVIndex].origin_cv} ({(currCVIndex + 1)} / {curriculumVitaes.length})</h3>
                        <div className={'card-tools row'}>
                            <div className="btn-group mr-2">
                                <button type="button" className="btn btn-default">Actions</button>
                                <button type="button"
                                        className="btn btn-default dropdown-toggle dropdown-icon"
                                        data-toggle="dropdown">
                                    <span className="sr-only">Toggle Dropdown</span>
                                </button>
                                <div className="dropdown-menu" role="menu">
                                    {userLoginInfo.is_superuser &&
                                        <a className='dropdown-item'
                                           rel="noreferrer"
                                           target='_blank'
                                           href={curriculumVitaes[currCVIndex].cv_display_url}>Download
                                            CV
                                        </a>
                                    }
                                    <a className='btn btn-info dropdown-item'
                                       rel="noreferrer"
                                       target='_blank'
                                       href={`/candidate/cv/upload?candidateId=${candidateId}`}>Add
                                        CV
                                    </a>
                                    {userLoginInfo.is_superuser &&
                                        <button className='dropdown-item' type={'button'}
                                                disabled={curriculumVitaes.length <= 1}
                                                onClick={() => onCVDelete()}>Xóa CV
                                        </button>
                                    }
                                </div>
                            </div>

                            <div className={'text-right'}>
                                <button className='btn' disabled={currCVIndex === 0} type={'button'}
                                        onClick={onCVBack}>
                                    <i className='fas fa-arrow-left'/> Back
                                </button>
                            </div>
                            <div className={'text-right'}>
                                <button className='btn'
                                        disabled={currCVIndex >= curriculumVitaes.length - 1}
                                        type={'button'} onClick={onCVNext}>
                                    <i className='fas fa-arrow-right'/> Next
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='card-body'
                         style={{height: '83vh', overflow: 'auto', resize: 'both'}}>
                        <div>
                            <Document
                                file={curriculumVitaes[currCVIndex].cv_display_url}
                                onLoadSuccess={pdfInfo => onLoadSuccess(pdfInfo, currCVIndex)}
                            >
                                {curriculumVitaes[currCVIndex].numPages && curriculumVitaes[currCVIndex].numPages.map(page =>
                                    (<Page pageNumber={page}
                                        // width={500} height={800}
                                           scale={1.5}
                                    />)
                                )}
                            </Document>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default CandidateCVFiles;
